import React from "react";
import AbstractPage from "./AbstractPage";

class SHECObervation extends AbstractPage {
  constructor(props) {
    super(props)

    this.title = "SHEC Observation";
  }

  render() {
    return ""
  }
}

export default SHECObervation;



// WEBPACK FOOTER //
// ./src/views/SHECObservation.js